import { batch } from 'react-redux'
import { makeActionCreator } from '../../config/store/utils'
import { getAllProvidersBuyer, getAllSupplierDetail } from '../../services/search'
import { formatDate } from '@chilecompra/react-kit/utils'
export const GET_PROVIDERS_TRADED_AMOUNTS = 'GET_PROVIDERS_TRADED_AMOUNTS'
export const GET_PROVIDERS_TRADED_AMOUNTS_ERROR = 'GET_PROVIDERS_TRADED_AMOUNTS_ERROR'
export const GET_PROVIDERS_TRADED_AMOUNTS_SUCCESS = 'GET_PROVIDERS_TRADED_AMOUNTS_SUCCESS'
export const onGetProvidersTradedAmounts = makeActionCreator(GET_PROVIDERS_TRADED_AMOUNTS)
export const onGetProvidersTradedAmountsError = makeActionCreator(GET_PROVIDERS_TRADED_AMOUNTS_ERROR, 'payload')
export const onGetProvidersTradedAmountsSuccess = makeActionCreator(GET_PROVIDERS_TRADED_AMOUNTS_SUCCESS, 'payload')
export const onGetProvidersTradedAmountsThunk = payload => async dispatch => {
  dispatch(onGetProvidersTradedAmounts())

  try {
    const { data = [] } = await getAllProvidersBuyer({
      buyers: payload.buyers,
      sectorId: payload.sectorId,
      year: payload.year,
      processId: 1
    })
    const enhancedData = data.payload.map(item => ({
      buyerId: item.linkBuyer,
      buyerName: item.buyer,
      amount: item.amountCLPAnual,
      amountUSD: item.amountUSDAnual,
      dni: item.rutProvider,
      name: item.provider,
      orders: item.qtyProcess
    }))
    const csv = [
      [
        'Nombre proveedor',
        'RUT proveedor',
        'Organismo comprador',
        'Código organismo comprador',
        'N° de órdenes de compra',
        'Monto transado',
        'Monto transado (USD)'
      ],
      ...enhancedData.map(item => [
        item.name,
        item.dni,
        item.buyerName,
        item.buyerId.slice(item.buyerId.lastIndexOf('/'), item.buyerId.length).replace('/', ''),
        item.orders,
        item.amount,
        item.amountUSD
      ])
    ]

    return dispatch(onGetProvidersTradedAmountsSuccess({ csv, data: enhancedData }))
  } catch (error) {
    return dispatch(onGetProvidersTradedAmountsError({ error }))
  }
}

export const GET_PROVIDERS_TRADED_AMOUNTS_DETAILS = 'GET_PROVIDERS_TRADED_AMOUNTS_DETAILS'
export const GET_PROVIDERS_TRADED_AMOUNTS_DETAILS_ERROR = 'GET_PROVIDERS_TRADED_AMOUNTS_DETAILS_ERROR'
export const GET_PROVIDERS_TRADED_AMOUNTS_DETAILS_SUCCESS = 'GET_PROVIDERS_TRADED_AMOUNTS_DETAILS_SUCCESS'
export const onGetProvidersTradedAmountsDetails = makeActionCreator(GET_PROVIDERS_TRADED_AMOUNTS_DETAILS)
export const onGetProvidersTradedAmountsDetailsError = makeActionCreator(
  GET_PROVIDERS_TRADED_AMOUNTS_DETAILS_ERROR,
  'payload'
)
export const onGetProvidersTradedAmountsDetailsSuccess = makeActionCreator(
  GET_PROVIDERS_TRADED_AMOUNTS_DETAILS_SUCCESS,
  'payload'
)
export const onGetProvidersTradedAmountsDetailsThunk = payload => async dispatch => {
  dispatch(onGetProvidersTradedAmountsDetails())

  try {
    const { data = [] } = await getAllSupplierDetail({
      buyers: payload.buyers,
      sectorId: payload.sectorId,
      year: payload.year,
      dni: payload.dni,
      idProcess: 1
    })
    const enhancedData = data.payload.map(item => ({
      acceptedAt: formatDate(new Date(item.dateProcess), 'dd-MM-yyyy'),
      amount: item.amountCLP,
      amountUSD: item.amountUSD,
      mechanism: item.typeProcess,
      orderId: item.codeProcess,
      status: item.stateProcess,
      linkOc: item.linkProcess
    }))

    return batch(() => {
      dispatch(onGetProvidersTradedAmountsDetailsSuccess({ data: enhancedData }))
      payload.callback && payload.callback()
    })
  } catch (error) {
    return dispatch(onGetProvidersTradedAmountsDetailsError({ error }))
  }
}

export const GET_PROVIDERS_BIDDINGS = 'GET_PROVIDERS_BIDDINGS'
export const GET_PROVIDERS_BIDDINGS_ERROR = 'GET_PROVIDERS_BIDDINGS_ERROR'
export const GET_PROVIDERS_BIDDINGS_SUCCESS = 'GET_PROVIDERS_BIDDINGS_SUCCESS'
export const onGetProvidersBiddings = makeActionCreator(GET_PROVIDERS_BIDDINGS)
export const onGetProvidersBiddingsError = makeActionCreator(GET_PROVIDERS_BIDDINGS_ERROR, 'payload')
export const onGetProvidersBiddingsSuccess = makeActionCreator(GET_PROVIDERS_BIDDINGS_SUCCESS, 'payload')
export const onGetProvidersBiddingsThunk = payload => async dispatch => {
  dispatch(onGetProvidersBiddings())

  try {
    const { data = [] } = await getAllProvidersBuyer({
      buyers: payload.buyers,
      sectorId: payload.sectorId,
      year: payload.year,
      processId: 2
    })
    const enhancedData = data.payload.map(item => ({
      buyerId: item.linkBuyer,
      buyerName: item.buyer,
      amount: item.amountCLPAnual,
      amountUSD: item.amountUSDAnual,
      dni: item.rutProvider,
      name: item.provider,
      orders: item.qtyProcess
    }))
    const csv = [
      [
        'Nombre proveedor',
        'RUT proveedor',
        'Organismo comprador',
        'Código organismo comprador',
        'N° de órdenes de compra',
        'Monto transado',
        'Monto transado (USD)'
      ],
      ...enhancedData.map(item => [
        item.name,
        item.dni,
        item.buyerName,
        item.buyerId.slice(item.buyerId.lastIndexOf('/'), item.buyerId.length).replace('/', ''),
        item.orders,
        item.amount,
        item.amountUSD
      ])
    ]

    return dispatch(onGetProvidersBiddingsSuccess({ csv, data: enhancedData }))
  } catch (error) {
    return dispatch(onGetProvidersBiddingsError({ error }))
  }
}

export const GET_PROVIDERS_BIDDINGS_DETAILS = 'GET_PROVIDERS_BIDDINGS_DETAILS'
export const GET_PROVIDERS_BIDDINGS_DETAILS_ERROR = 'GET_PROVIDERS_BIDDINGS_DETAILS_ERROR'
export const GET_PROVIDERS_BIDDINGS_DETAILS_SUCCESS = 'GET_PROVIDERS_BIDDINGS_DETAILS_SUCCESS'
export const onGetProvidersBiddingsDetails = makeActionCreator(GET_PROVIDERS_BIDDINGS_DETAILS)
export const onGetProvidersBiddingsDetailsError = makeActionCreator(GET_PROVIDERS_BIDDINGS_DETAILS_ERROR, 'payload')
export const onGetProvidersBiddingsDetailsSuccess = makeActionCreator(GET_PROVIDERS_BIDDINGS_DETAILS_SUCCESS, 'payload')
export const onGetProvidersBiddingsDetailsThunk = payload => async dispatch => {
  dispatch(onGetProvidersBiddingsDetails())

  try {
    const { data = [] } = await getAllSupplierDetail({
      buyers: payload.buyers,
      sectorId: payload.sectorId,
      year: payload.year,
      dni: payload.dni,
      idProcess: 2
    })
    const enhancedData = data.payload.map(item => ({
      acceptedAt: formatDate(new Date(item.dateProcess), 'dd-MM-yyyy'),
      amount: item.amountCLP,
      amountUSD: item.amountUSD,
      mechanism: item.typeProcess,
      orderId: item.codeProcess,
      status: item.stateProcess,
      linkOc: item.linkProcess
    }))

    return batch(() => {
      dispatch(onGetProvidersBiddingsDetailsSuccess({ data: enhancedData }))
      payload.callback && payload.callback()
    })
  } catch (error) {
    return dispatch(onGetProvidersBiddingsDetailsError({ error }))
  }
}
